import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import Modal from '@components/Modal/Modal';

import { IUnsavedChangesModalProps } from './UnsavedChangesModal.interface';

import './style.scss';

const UnsavedChangesModal: FC<IUnsavedChangesModalProps> = ({ open, onDiscard, onContinue }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onContinue}
      onLeftAction={onDiscard}
      leftActionTitle={t('unsavedChanges.discard')}
      onRightAction={onContinue}
      rightActionTitle={t('unsavedChanges.continue')}
      className="unsaved-changes-modal"
    >
      <Box
        component="img"
        className="unsaved-changes-modal__img"
        sx={{
          height: 80,
          width: 91,
        }}
        alt={t('unsavedChanges.title')}
        src="/images/img-unsaved-changes.svg"
      />
      <Typography variant="h5" className="unsaved-changes-modal__title">
        {t('unsavedChanges.title')}
      </Typography>
      <Typography variant="body1" className="unsaved-changes-modal__question">
        {t('unsavedChanges.question')}
      </Typography>
      <Typography variant="body1" className="unsaved-changes-modal__warning">
        {t('unsavedChanges.warning')}
      </Typography>
    </Modal>
  );
};

export default UnsavedChangesModal;
